export const OPEN_SVR_QUESTION_EVENT = 'svr:openQuestion';

const HIGHLIGHT_CLASS = 'report-question-highlight';
const HIGHLIGHT_DURATION = 2000;
const WAIT_FOR_ELEMENT_TIMEOUT = 1500;
const TRANSITION_FALLBACK_TIMEOUT = 800;
const COLLAPSE_WRAPPER_SELECTOR = '.ReactCollapse--collapse';

export const dispatchOpenQuestion = (questionId) => {
  if (!questionId) return;
  window.dispatchEvent(
    new CustomEvent(OPEN_SVR_QUESTION_EVENT, { detail: { questionId } })
  );
};

const waitForElement = (id, timeout = WAIT_FOR_ELEMENT_TIMEOUT) => new Promise((resolve) => {
  const start = Date.now();
  const check = () => {
    const el = document.getElementById(id);
    if (el) return resolve(el);
    if (Date.now() - start > timeout) return resolve(null);
    return requestAnimationFrame(check);
  };
  check();
});

const waitForCollapseTransitionEnd = (el) => new Promise((resolve) => {
  if (!el) return resolve();
  // react-collapse sets height: 'auto' when fully opened (no animation in progress).
  if (el.style.height === 'auto' || el.style.height === '') return resolve();

  let done = false;
  const onEnd = (event) => {
    if (event && event.propertyName && event.propertyName !== 'height') return;
    if (done) return;
    done = true;
    el.removeEventListener('transitionend', onEnd);
    resolve();
  };
  el.addEventListener('transitionend', onEnd);
  setTimeout(onEnd, TRANSITION_FALLBACK_TIMEOUT);
  return undefined;
});

export const scrollAndHighlightQuestion = async (questionId) => {
  if (!questionId) return;
  const el = await waitForElement(`svr-question-${questionId}`);
  if (!el) return;

  const collapseWrapper = el.closest(COLLAPSE_WRAPPER_SELECTOR);
  await waitForCollapseTransitionEnd(collapseWrapper);

  el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  el.classList.add(HIGHLIGHT_CLASS);
  setTimeout(() => el.classList.remove(HIGHLIGHT_CLASS), HIGHLIGHT_DURATION);
};
